<template>
  <div>
    <div v-if="dataTable.length > 0"  class="flex-display ai-center js-between">
    <div class="width-100"></div>
        <div
            v-for="(label, labelIndex) in labels"
            :key="labelIndex"
            class="date-box"
            :class="label.type == 'number' ? 'number-fix' : ''"
        >
            <p class="text-font-10 color-gray">{{ label.name }}</p>
        </div>
    </div>
    <div v-if="dataTable.length > 0">
        <div
            v-for="(item, index) in dataTable"
            :key="index"
            class="pd-b-4 flex-display ai-center pd-t-5"
            :class="{ 'border-b': index < dataTable.length - 1 }"
        >
        <div class="flex-display ai-center width-100 pd-t-5">
        <div>
            <div class="box-image">
            <avatar
                :rounded="false"
                :username="item.nameTH"
                :src="`${urlImage}${item._id}/${item.profileImg}`"
                :size="30"
            ></avatar>
            </div>
        </div>
        <div class="pd-l-5 text-height-12 text-left">
            <p class="text-font-14 mg-y-less color-black-strong pd-b-5">
            {{ item.nameTH }} {{ item.surnameTH }}
            </p>
            <span
            v-if="typeof item.institution != 'undefined'"
            class="text-font-10 color-gray"
            >{{ item.institution }}</span
            >
            <span v-else class="text-font-10 color-gray"
            >สำเร็จเมื่อ {{ item.date | dateTh }}</span
            >
        </div>
        </div>
        <div
          v-for="(label, labelIndex) in labels"
          :key="labelIndex"
          class="date-box message-over clamp1 height-30"
          :class="label.type == 'number' ? 'number-fix' : ''"
        >
          <p v-if="label.type == 'date'" class="text-font-10">
            {{ item[label.key] | dateTimeTh }}
          </p>
          <p v-else-if="label.type == 'number'" class="text-font-10">
            {{ item[label.key] | commaNoDot }}
          </p>
          <p v-else class="text-font-10">{{ item[label.key] }}</p>
        </div>
      </div>
    </div>
    <div v-if="dataTable.length == 0" class="text-center">
      <p class="color-gray pd-y-1">*** ไม่มีข้อมูล ***</p>
    </div>
  </div>
</template>

<script>
import Avatar from "vue-avatar";
export default {
  components: {
    Avatar,
  },
  props: {
    dataTable: {
      type: Array,
      default() {
        return [];
      },
    },
    labels: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  data() {
    return {
      urlImage: process.env.VUE_APP_BASE_URL_IMAGE,
    }
  },
};
</script>

<style scoped>
.date-box {
  text-align: center;
  width: 350px;
}
</style>